import(/* webpackMode: "eager" */ "/tmp/8df18a2d2cdc1e0/app/global-error.tsx");
